/** Mock payloads until dedicated analytics APIs ship. */

function daysAgo(n) {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() - n);
  return d.toISOString().slice(0, 10);
}

export const REVENUE_MOVEMENT_MOCK = {
  dataSource: 'mock',
  currencyCode: 'DKK',
  filters: { start: daysAgo(13), end: daysAgo(0), accountId: null },
  totals: { cmp: 428500, pos: 91200, app: 18400, currencyCode: 'DKK' },
  series: Array.from({ length: 14 }, (_, i) => {
    const date = daysAgo(13 - i);
    const cmp = 22000 + ((i * 1373) % 9000);
    const pos = i % 3 === 0 ? 0 : 4000 + ((i * 611) % 3500);
    const app = i % 4 === 0 ? 0 : 800 + ((i * 211) % 900);
    return { date, cmp, pos, app, currencyCode: 'DKK' };
  }),
  notes: [
    'Mock series until GET /api/revenue/movement is available.',
    'POS/APP may be zero on live data until those pipelines flow into vi_events.',
  ],
};

export const SCAN_HEATMAP_MOCK = {
  dataSource: 'mock',
  totalScans: 1842,
  hours: Array.from({ length: 24 }, (_, h) => h),
  gates: [
    {
      gateId: 'gate-a',
      gateName: 'Gate A — Main',
      zoneId: 'main',
      zoneName: 'Main entrance',
      byHour: [
        0, 0, 0, 0, 0, 2, 8, 24, 66, 120, 98, 72, 54, 48, 61, 88, 140, 176, 132, 74, 36, 14, 4, 1,
      ],
    },
    {
      gateId: 'gate-b',
      gateName: 'Gate B — East',
      zoneId: 'east',
      zoneName: 'East concourse',
      byHour: [
        0, 0, 0, 0, 0, 0, 4, 12, 38, 74, 66, 41, 28, 22, 30, 52, 90, 118, 84, 40, 18, 6, 2, 0,
      ],
    },
    {
      gateId: 'gate-c',
      gateName: 'Gate C — VIP',
      zoneId: 'vip',
      zoneName: 'VIP lounge',
      byHour: [
        0, 0, 0, 0, 0, 0, 1, 6, 14, 28, 22, 16, 12, 10, 14, 20, 34, 42, 30, 12, 5, 2, 0, 0,
      ],
    },
    {
      gateId: 'gate-d',
      gateName: 'Gate D — South',
      zoneId: 'south',
      zoneName: 'South turnstiles',
      byHour: [
        0, 0, 0, 0, 0, 1, 6, 18, 48, 86, 70, 44, 30, 24, 36, 58, 96, 124, 90, 46, 20, 8, 2, 0,
      ],
    },
  ],
  notes: [
    'Mock heatmap until GET /api/scans/heatmap is available.',
    'ACP gate/zone currently lives in raw payload JSON — expect empty live data until ACP flows.',
  ],
};

export const DATA_FRESHNESS_MOCK = {
  checkedAt: new Date().toISOString(),
  accountId: null,
  sources: [
    {
      source: 'CMP',
      status: 'fresh',
      lastEventAt: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
      lastIngestedAt: new Date(Date.now() - 4 * 60 * 1000).toISOString(),
      lagSeconds: 300,
      eventCount24h: 840,
    },
    {
      source: 'POS',
      status: 'stale',
      lastEventAt: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
      lastIngestedAt: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
      lagSeconds: 21600,
      eventCount24h: 12,
    },
    {
      source: 'APP',
      status: 'empty',
      lastEventAt: null,
      lastIngestedAt: null,
      lagSeconds: null,
      eventCount24h: 0,
    },
    {
      source: 'ACP',
      status: 'empty',
      lastEventAt: null,
      lastIngestedAt: null,
      lagSeconds: null,
      eventCount24h: 0,
    },
  ],
};

export const ERP_EXPORT_SETTINGS_MOCK = {
  provider: 'dynamics',
  status: 'configured',
  frequency: 'daily',
  // Matches backend REQUIRED_REVENUE_TYPES (CMP product_type keys).
  glMapping: [
    { revenueType: 'admission', glAccount: '3000', glAccountName: 'Admission / tickets' },
    { revenueType: 'seasoncard', glAccount: '3100', glAccountName: 'Season cards' },
    { revenueType: 'added_product', glAccount: '3200', glAccountName: 'Add-ons / merch' },
  ],
  dimensions: [
    { key: 'venue', sourceField: 'venueId', erpDimension: 'COSTCENTER' },
    { key: 'event', sourceField: 'eventId', erpDimension: 'PROJECT' },
  ],
  lastExportAt: new Date(Date.now() - 26 * 60 * 60 * 1000).toISOString(),
  lastExportStatus: 'success',
  errorMessage: null,
  accountId: null,
  mappingComplete: true,
};
